'use strict';

// @ngInject
module.exports = function () {

    this.getDate = function getDate() {
        return new Date();
    };

};